import * as integrationsConnectorsCommands from '@Integrations/Connectors/commands-vue-composables'
import * as integrationsConnectorsQueries from '@Integrations/Connectors/queries-vue-composables'
import * as integrationsUsersQueries from '@Integrations/Users/queries-vue-composables'

export function useAdminConfigureConnectorPage(){
	return {
		useConfigureConnectorCommand: integrationsConnectorsCommands.useConfigureConnectorCommandV1,
		useConnectorDetailsQuery: integrationsConnectorsQueries.useConnectorDetailsQueryV1,
		useConnectorProvidersQuery: integrationsConnectorsQueries.useConnectorProvidersQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
	}
}

export function useAdminConnectorDetailsPage(){
	return {
		useConnectorDetailsQuery: integrationsConnectorsQueries.useConnectorDetailsQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDeleteConnectorCommand: integrationsConnectorsCommands.useDeleteConnectorCommandV1,
		usePermanentDeleteConnectorCommand: integrationsConnectorsCommands.usePermanentDeleteConnectorCommandV1,
	}
}

export function useAdminManageConnectorsPage(){
	return {
		useConnectorsOfOrganizationQuery: integrationsConnectorsQueries.useConnectorsOfOrganizationQueryV1,
		useCreateConnectorCommand: integrationsConnectorsCommands.useCreateConnectorCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
	}
}

